
<template>
  <div class="task-content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="header">
        <div class="back"  @click="$router.go(-1)">返回</div>
        <div class="task-title" v-if="isChangeService">
          {{ taskTitle || '配置任务包' }}
          <span v-if="taskTitle" @click="visible7 = true">修改</span>
        </div>
        <div class="task-title" v-else>
          {{ taskTitle && newTaskTitleTxt ? taskTitle + '(' + newTaskTitleTxt + ')' : taskTitle || '配置任务包' }}
          <span v-if="taskTitle" @click="visible7 = true">修改</span>
        </div>
    </div>

    <div class="title">基本配置</div>
    <el-form label-width="100px" label-position="right" class="demo-ruleForm">
      <div class="basic-conetent">
        <div :style="disabled ? 'display:flex;width:850px;' : 'display:flex;width:800px;padding-left:20px;'">
          <!-- 委托方 -->
          <el-form-item style="width: 400px">
            <span slot="label" style="color: red">*</span>
            <span slot="label">委托方<span style="display: inline-block; width: 4px"></span></span>
            <el-select style="width: 300px; margin-left: 10px" v-model="sendTenantName" @change="handleSelectFactory"
              filterable placeholder="请选择委托方" v-if="!disabled">
              <el-option v-for="(item, index) in sendTenantList" :key="index" :label="item.sendTenantName"
                :value="item.sendTenantName"></el-option>
            </el-select>
            <span v-else>{{ sendTenantName }}</span>
          </el-form-item>
          <!-- 服务商 -->
          <el-form-item style="padding-left: 15px">
            <span slot="label" style="color: red">*</span>
            <span slot="label">服务商<span style="display: inline-block; width: 6px"></span></span>
            <div style="margin-left: 10px">{{ serviceTenantName }}</div>
            <div></div>
          </el-form-item>
        </div>
        <div style="display: flex">
          <div class="management-list" style="width: 400px">
            <div class="management-name"><span style="color: red">*</span>发布人员</div>
            <div style="text-align: left">
              <span class="designee" v-show="departmentData !== '' || departmentData !== null"
                v-for="(item, index) in departmentData" :key="index"><span class="select-name">{{ item.staffName
                }}</span>
                <span v-if="!disabled" @click="delDepartmentSingle(index)"
                  class="ml10 cursor-sty font-S19">×</span></span>
              <span class="select-department" v-if="!disabled" @click="addPeople">{{
                  departmentData && departmentData.length > 0 ? '修改' : '指定人员'
              }}</span>
            </div>
          </div>
          <div class="base-info" :style="disabled ? '' : 'padding-left:20px;'">
            <div class="base-title"><span style="color: red">*</span>执行部门</div>
            <div class="depart-choose" @click="visible5 = true" v-if="!disabled">
              <span v-if="departmentListII.length == 0" class="place-choose">请选择</span>
              <span class="place-show" v-else>{{ this.getDeliverNameII(departmentListII) }} </span>
            </div>
            <div style="border: 0 none" class="depart-choose" v-else>{{ this.getDeliverNameII(departmentListII) }}</div>
          </div>
        </div>
        <div style="display: flex;">
          <!-- 发布周期 -->
          <el-form-item :style="disabled ? 'padding-right:74px;' : 'padding-right:90px'">
            <span slot="label" style="color: red">*</span>
            <span slot="label">发布周期 </span>
            <el-radio-group v-model="timeType" :disabled="disabled">
              <el-radio label="按年">按年</el-radio>
              <el-radio label="按月">按月</el-radio>
              <el-radio label="自定义">自定义</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 执行日期 -->
          <el-form-item style="width: 400px;"
            v-if="timeType == '按年' || timeType == '按月' || timeType == '自定义' || disabled">
            <span slot="label" style="color: red">*</span>
            <span slot="label">执行日期 </span>
            <div>{{ startTime || ' -' }} 至 {{ endTime || ' -' }}</div>
          </el-form-item>

        </div>
        <div style="display: flex; width: 800px">
          <!-- 选择时间 -->
          <el-form-item style="width: 400px; padding-left: 20px" v-if="timeType == '自定义' && !disabled">
            <span slot="label" style="color: red">*</span>
            <span slot="label">选择时间 </span>
            <el-date-picker v-model="timeRange" type="daterange" align="center" unlink-panels range-separator="至"
              start-placeholder="起始时间" end-placeholder="截止时间" value-format="yyyy-MM-dd"
              style="width: 300px; float: left" :clearable="false" :disabled="disabled" />
          </el-form-item>
          <el-form-item style="width: 400px; padding-left: 20px" v-if="timeType == '按年' && !disabled">
            <span slot="label" style="color: red">*</span>
            <span slot="label">选择时间 </span>
            <el-date-picker v-model="year" type="year" align="center" format="yyyy年" placeholder="请选择年份"
              style="width: 300px; float: left" value-format="yyyy" :clearable="false" :disabled="disabled" />
          </el-form-item>
          <el-form-item style="width: 400px; padding-left: 20px" v-if="timeType == '按月' && !disabled">
            <span slot="label" style="color: red">*</span>
            <span slot="label">选择时间 </span>
            <el-date-picker v-model="month" type="month" align="center" format="yyyy年MM月" placeholder="请选择核算月份"
              style="width: 300px; float: left" value-format="yyyy-MM" :clearable="false" :disabled="disabled" />
          </el-form-item>
          <!-- 任务类型 -->
          <el-form-item v-if="!disabled" :style="disabled ? '' : 'margin-left:20px'">
            <span slot="label" style="color: red">*</span>
            <span slot="label">任务类型</span>
            <el-select style="width: 300px; margin-left: 5px" v-model="taskType" filterable placeholder="请选择任务类型">
              <el-option v-for="(item, index) in getCodeListByKey('任务类型')" :key="index" :label="item.text" :value="item.value"></el-option>
            </el-select>

          </el-form-item>
        </div>

        <!-- 新执行方 新执行部门 -->
         <div style="display: flex;" v-if="detail.isChangeService === 'Y'">
          <!-- 新执行方 -->
          <el-form-item :style="disabled ? 'padding-right:74px;' : 'padding-right:90px'">
            <span slot="label" style="color: red">*</span>
            <span slot="label">新执行方 </span>
            <div style="width: 230px;text-align:left">{{ detail.newServiceTenantName || '-' }}</div>
          </el-form-item>
          <!-- 新执行部门 -->
          <el-form-item style="width: 400px;">
            <span slot="label" style="color: red">*</span>
            <span slot="label">新执行部门 </span>
            <div>{{ this.getDeliverNameII(newDepartmentListII) || '-' }}</div>
          </el-form-item>
        </div>
      </div>

      <div class="title" style="padding-bottom:0;">任务明细</div>
      <templateConfig @setRule="setRule" @openTemplate="openTemplate" :sendTenantGuid="sendTenantGuid" :sendTenantName="sendTenantName" :datasetTenantGuids="datasetTenantGuids" :disabled="disabled"
        :configData="tableDataII" :isPartDisabled="true" :taskPriceDisabled="true" :taskPriceModel="taskPriceModel" ref="templateConfig"></templateConfig>
        <div class="btn-groups">
          <el-button class="btn-common btn-border-gray" size="mini" type="info" @click="$router.go(-1)">取消</el-button>
          <el-button  class="btn-common" size="mini" type="info"  @click="submitReq(1)">修改</el-button>
        </div>
    </el-form>

    <el-dialog title="选择人员" :visible.sync="visible3" width="70%" center>
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input v-model="filterText" class="ipt-sty mt15" placeholder="请输入部门名称"></el-input>
            <p class="fontC-bbb">组织架构</p>
            <el-tree class="filter-tree" :data="areaData" :props="defaultProps" :show-checkbox="true" node-key="guid"
              :filter-node-method="filterNodeDep" @node-click="nodeClick" ref="treeDep" check-strictly
              @check-change="handleNodeClick1" @check="handleNodeClick1">
              <div class="custom-tree-node" slot-scope="{ node, data }">
                <img :src="data.icon" alt="" />
                <!-- <img src="../../assets/images/icon_per.png" alt=""> -->
                <span>{{ data.label }} <span class="remark-class" v-if="data.remark">（{{ data.remark }}）</span></span>
              </div>
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ departmentList.length }}个成员</p>
            <el-button size="medium" type="danger" @click="delDepartment()" class="fr" style="margin-top: 5px">批量删除
            </el-button>
            <el-table :data="departmentList" border height="280px" style="width: 100%"
              @selection-change="handleSelectionChange1">
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column header-align="center" align="center" show-overflow-tooltip prop="staffName" label="名称">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible3 = false">取消</el-button>
        <el-button size="medium" type="info" @click="departmentSure()">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="填写品种任务量" :visible.sync="visible2" width="40%" center>
      <el-table border :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="产品名称" show-overflow-tooltip header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="name" label="任务量" width="180" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input-number v-if="!disabled" v-model="scope.row.goodsCount" :min="0" :step="1" size="small">
            </el-input-number>
            <span v-else>{{ scope.row.goodsCount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="goodsSpec" label="产品规格" show-overflow-tooltip header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.goodsSpec }}</template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible2 = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitForm()">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择任务模版" :visible.sync="visible4" width="900px" center>
      <el-tabs v-model="activeTemlate">
        <el-tab-pane label="超级模版" name="0"></el-tab-pane>
        <el-tab-pane label="项目模版" name="1"></el-tab-pane>
      </el-tabs>
      <!-- 超级模版 -->
      <section v-if="activeTemlate == 0">
        <section style="margin-top: 10px">
          <div class="search-row">
            <div class="search-col">
              <span class="search-name">任务名称：</span>
              <el-input v-model="superPage.taskContentName" style="width: 200px" placeholder="请输入模版名称"></el-input>
            </div>
            <div class="search-col">
              <span class="search-name">系统功能：</span>
              <el-input v-model="superPage.menuName" style="width: 200px" placeholder="请输入模版名称"></el-input>
            </div>
            <div class="search-col" style="margin-left: 20px">
              <el-button size="medium" type="info" @click="getSuperTemplateList">搜索</el-button>
              <el-button size="medium" type="danger" @click="emptySearchSuper">清空</el-button>
            </div>
          </div>
        </section>

        <el-table border :data="superTemplateList" row-key="guid" ref="superTable" style="width: 100%"
          @selection-change="handleSelectSuper">
          <el-table-column type="selection" :reserve-selection="true"> </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              <!-- {{ scope.$index + 1 }} -->
              {{ (superPage.pageIndex - 1) * superPage.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="taskContentName" label="任务名称" show-overflow-tooltip header-align="center"
            align="center">
            <template slot-scope="scope">{{ scope.row.taskContentName }}</template>
          </el-table-column>
          <el-table-column prop="staffTaskNote" label="任务简述" show-overflow-tooltip header-align="center" align="center">
            <template slot-scope="scope">{{ scope.row.staffTaskNote }}</template>
          </el-table-column>
          <el-table-column prop="tenantTaskNote" label="任务说明" show-overflow-tooltip header-align="center"
            align="center">
          </el-table-column>
          <el-table-column prop="taskTotal" label="系统功能" show-overflow-tooltip header-align="center" align="center">
            <template slot-scope="scope">{{ scope.row.menuName }}</template>
          </el-table-column>
        </el-table>
        <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1" :page-sizes="[10, 100, 200]" :current-page="superPage.pageIndex"
          :page-size="superPage.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="superPage.totalRows">
        </el-pagination>
      </section>
      <!-- 项目模版 -->
      <section v-if="activeTemlate == 1">
        <section style="margin-top: 10px">
          <div class="search-row">
            <div class="search-col">
              <span class="search-name">发布药企：</span>
              <el-select v-model="schemPage.sendTenantGuid" @change="handleChangeCompany" style="width: 300px"
                filterable placeholder="请选择委托方">
                <el-option v-for="item in sendTenantList" :key="item.sendTenantGuid" :label="item.sendTenantName"
                  :value="item.sendTenantGuid"></el-option>
              </el-select>
            </div>
            <div class="search-col">
              <span class="search-name">模版名称：</span>
              <el-input v-model="schemPage.templateName" style="width: 300px" placeholder="请输入模版名称"></el-input>
            </div>
          </div>
          <div class="search-row">
            <div class="search-col">
              <span class="search-name">下发部门：</span>
              <el-select v-model="schemPage.organisationInfo" filterable placeholder="请选择执行部门" class="fl"
                style="width: 300px">
                <el-option v-for="item in organisationList" :key="item.guid" :label="item.organisationName"
                  :value="item.guid"></el-option>
              </el-select>
            </div>
            <div class="search-col" style="margin-left: 220px">
              <el-button size="medium" type="info" @click="getSchemeTemplateList">搜索</el-button>
              <el-button size="medium" type="danger" @click="emptySearchScheme">清空</el-button>
            </div>
          </div>
        </section>

        <el-table border :data="schemeTemplateList" row-key="guid" ref="dataTable" style="width: 100%"
          @select="handleSelectScheme">
          <el-table-column type="selection" :reserve-selection="true"> </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              <!-- {{ scope.$index + 1 }} -->
              {{ (schemPage.pageIndex - 1) * schemPage.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="templateName" label="模版名称" show-overflow-tooltip header-align="center" align="center">
            <template slot-scope="scope">{{ scope.row.templateName }}</template>
          </el-table-column>
          <el-table-column prop="tenantName" label="发布药企" show-overflow-tooltip header-align="center" align="center">
            <template slot-scope="scope">{{ scope.row.tenantName }}</template>
          </el-table-column>
          <el-table-column prop="organisationList" label="发布部门" show-overflow-tooltip header-align="center"
            align="center">
            <template slot-scope="scope">{{ getDeliverName(scope.row.organisationInfo) }}</template>
          </el-table-column>
          <el-table-column prop="taskTotal" label="系统功能" show-overflow-tooltip header-align="center" align="center">
            <template slot-scope="scope">共{{ scope.row.taskTotal }}项</template>
          </el-table-column>
        </el-table>
        <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :page-sizes="[10, 100, 200]" :current-page="schemPage.pageIndex"
          :page-size="schemPage.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="schemPage.totalRows">
        </el-pagination>
      </section>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="cancelChooseTemplate">取消</el-button>
        <el-button size="medium" type="info" @click="sureChooseTemplate">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择部门" :visible.sync="visible5" width="70%" center>
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input v-model="filterTextII" class="ipt-sty mt15" placeholder="请输入部门名称"></el-input>
            <p class="fontC-bbb">组织架构</p>
            <el-tree class="filter-tree" :data="areaDataII" :props="defaultPropsII" :filter-node-method="filterNodeII"
              @check="handleNodeClickII" :check-strictly="true" show-checkbox ref="treeII" node-key="guid"
              v-if="visible5">
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ departmentListII.length }}个部门</p>
            <el-button size="medium" type="danger" @click="delDepartmentII()" class="fr" style="margin-top: 5px">批量删除
            </el-button>
            <el-table :data="departmentListII" border height="280px" style="width: 100%"
              @selection-change="handleSelectionChangeII">
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column header-align="center" align="center" show-overflow-tooltip prop="organisationName"
                label="名称">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible5 = false">取消</el-button>
        <el-button size="medium" type="info" @click="departmentSureII()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改任务包名称" :visible.sync="visible7" width="800px">
      <!-- 转派任务可修改任务包全名 -->
      <div class="title-memo" v-if="isChangeService"> 
            <div class="title-memo-title">
              <span style="color: red">*</span>
              <span style="font-weight:600">任务包名称: </span>
            </div>
            <el-input style="width: 80%;margin-left:10px;" type="text" :maxlength="50" placeholder="仅可输入50个字符" @change="checkTaskTitle" v-model="taskTitle"/>
        </div>
        <div class="title-memo" v-else> 
            <div class="title-memo-title">
              <span style="color: red">*</span>
              <span style="font-weight:600">任务包名称: </span>
            </div>
            <div class="title-memo-label">{{ taskTitle }}</div>
           <el-input style="width: 290px;margin-left:10px;" type="text"  :maxlength="8" placeholder="仅可输入8个字符" v-model="newTaskTitleTxt"/>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="visible7 = false;">取 消</el-button>
        <el-button size="medium" type="info" @click="visible7 = false;" v-loading.fullscreen.lock="fullscreenLoading">确 定
        </el-button>
      </span>
    </el-dialog>
     <el-dialog title="执行规则" :visible.sync="visible8" width="670px">
      <el-form label-width="140px" label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">应用端</span>
          <div style="display:flex;">
            <span style="display:flex;">
              <el-checkbox  style="margin-right: 10px;" v-model="ismobile"></el-checkbox>移动端
            </span>
            <span style="display:flex;margin-left:20px">
              <el-checkbox disabled style="margin-right: 10px;" v-model="ispc"></el-checkbox>PC端
            </span>
          </div>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">执行顺序</span>
          <div style="display:flex;flex-direction:column;text-align: left;">
            <el-radio  style="margin-bottom:10px" v-model="orderType" label="1">按任意顺序执行任务</el-radio>
            <el-radio  v-model="orderType" label="2">必须按顺序执行（上个任务执行完成，才可执行下个任务）</el-radio>
          </div>
        </el-form-item>
        <el-form-item>
          <span slot="label" :style="orderType == 2 ? 'color:red;' : 'color:white'">*</span>
          <span slot="label">执行间隔</span>
          <span style="display:flex;">
            <el-checkbox style="margin-right: 10px;" v-model="isNextDay"></el-checkbox>上个任务执行完成后的<el-input
              style="width:50px;margin:0 5px;" v-model="nextDay"  :maxlength="2" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>天，才可执行下一任务。
          </span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="cancelRule">取 消</el-button>
        <el-button size="medium" type="info" @click="comfirmRule" >确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import templateConfig from '@/components/templateConfig.vue';
export default {
  data() {
    return {
      taskPriceModel:'',
      timeType: '按月',
      timeRange: '',
      year: '',
      month: '',
      startTime: '',
      endTime: '',
      originalTaskTitle:'', // 原始任务包名称
      taskTitle: '',
      tenantName: '',
      templateGuid: '',
      templateName: '',
      tenantList: [],
      taskContentList: [],
      templateList: [],
      tableDataII: [],
      visible2: false,
      page: {
        pageIndex: 1,
        pageSize: 100,
        totalPage: 0,
        totalRows: 0,
        taskContentName: '',
        tenantName: '',
        tenantGuid: '',
      },
      schemPage: {
        serviceTenantGuid: localStorage.guid,
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        isSuper: 'N',
        sendTenantGuid: '',
        tenantGuid: localStorage.guid,
        tenantName: '', //药企名称
        templateName: '', //模版名称
        organisationInfo: '',
      },
      superPage: {
        tenantGuid: localStorage.guid,
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        taskContentName: '', //任务名称
        menuName: '', //菜单名称
      },

      superTemplateList: [], //超级模版列表
      schemeTemplateList: [], //普通模版列表
      templateSelectd: '', //被临时选中的项目模板
      chooseTemplate: '', //最终被选中的模版

      organisationList: [],
      sendTenantList: [],
      tableData: [],
      multipleSelection: [],

      visible3: false,
      area: [],
      departmentList: [],
      departmentData: '',
      areaData: [],
      delList: [],
      filterText: '',
      fullscreenLoading: false,
      defaultProps: {
        id: 'guid',
        label: 'organisationName',
        children: 'children',
      },
      disabled: false,
      detail: {},
      serviceTenantName: null,
      sendTenantName: null,
      sendTenantGuid: null,
      serviceTenantGuid: null,
      loadingCount: 0,

      visible4: false,
      activeTemlate: 0,

      departmentListII: [],
      visible5: false,
      areaII: [],
      areaDataII: [],
      delListII: [],
      filterTextII: '',
      tempSuperTemplate: [], //临时选中的超级模版
      defaultPropsII: {
        id: 'guid',
        label: 'organisationName',
        children: 'children',
        disabled: this.disabledTreeNode,
      },
      taskDetailList: [],
      
      visible7: false,
      newTaskTitleTxt: '',

      visible8: false,
      orderType: '1',
      isNextDay: false,
      ismobile: true,
      ispc: false,
      nextDay:'',
      taskType: '',
      templateType:''
    };
  },
  created() {
    this.getSendTenantList();
    // this.getSchemeTemplateList();
    // this.getSuperTemplateList();
    this.getTenantList();
    this.getTaskContentList();
    this.getDetail();
  },
  components: {
    templateConfig,
  },
  watch: {
     orderType(newVal) {
      if (newVal == '2') {
        this.isNextDay = true;
        if(!this.$route.query.guid){
          this.nextDay = 15;
        }
      }else{
         this.isNextDay = false;
         this.nextDay = '';
      }
    },
    nextDay(newVal){
      if(newVal){
        this.orderType = '2'
        this.isNextDay = true;
      }
    },
    timeRange(newVal) {
      if (!newVal) return;
      this.startTime = newVal[0];
      this.endTime = newVal[1];
    },
    filterText(val) {
      this.$refs.treeDep.filter(val);
    },
    year(year) {
      if (this.disabled) return;
      if (!year) return;
      this.startTime = year + '-01-01';
      this.endTime = year + '-12-31';
    },
    month(month) {
      if (this.disabled) return;
      if (!month) return;

      var tenantList = this.tenantList;
      var tenantGuid;
      var reqDate = month + '-01';
      tenantList.forEach((item) => {
        if (item.tenantName == this.sendTenantName) {
          tenantGuid = item.guid;
        }
      });
      if (!tenantGuid) {
        this.$message.error('请先选择任务模版');
        return;
      }
      this.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-account-month-full-area?date=` +
          reqDate +
          '&tenantGuid=' +
          tenantGuid,
        )
        .then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.startTime = resp.data.data.split(',')[0];
            this.endTime = resp.data.data.split(',')[1];
          }
        });
    },
    timeType() {
      if (this.disabled) return;
      this.startTime = '';
      this.endTime = '';
      this.year = '';
      this.month = '';
    },
  },
  computed:{
    // 数据集候选双池（2026-09-21，工作任务派发视角）：委托方+服务方（FOUR-2996 tenantGuids 通道）。
    // 服务方初始=登录企业（data 里 serviceTenantGuid 兜底），详情加载后覆盖为包的服务方——
    // 详情未到时退化单池=登录企业，与改造前 FOUR-3010 口径等价，不会出现空候选
    datasetTenantGuids() {
      let pools = [];
      if (this.sendTenantGuid) pools.push(this.sendTenantGuid);
      if (this.serviceTenantGuid && pools.indexOf(this.serviceTenantGuid) < 0) pools.push(this.serviceTenantGuid);
      return pools;
    },
    isChangeService() {
      return this.detail.isChangeService === 'Y' && this.detail.bizApproveState === 'Y'
    },
    newDepartmentListII() { // 新执行部门 (转派)
      let arr = []
      if (this.detail.organisationInfo) {
        let organisationInfo = JSON.parse(this.detail.organisationInfo);
        organisationInfo.forEach((item) => {
          arr.push({
            guid: item.guid,
            organisationName: item.name,
            nodeType:item.objectType=='组织'||!item.objectType?'1':'2'

          });
        });
      }
      return arr
    }
  },
  methods: {
    cancelRule(){
      let nextDay = this.detail.nextDay;
      let orderType = this.detail.orderType;
      if (orderType == 1 || !orderType) {
        this.orderType = '1';
        this.isNextDay = false;
        this.nextDay = '';
      }
      if (orderType == 2) {
        this.orderType = '2';
        this.isNextDay = true;
        this.nextDay = nextDay;
      }
      this.visible8 = false;

    },
    comfirmRule(){
      if (!this.ismobile) {
        this.$message.error('请选择应用端');
        return;
      }
      if (!this.isNextDay&&this.orderType==2) {
        this.$message.error('请勾选执行间隔');
        return;
      }
      if (!this.nextDay&&this.orderType==2) {
        this.$message.error('请填写间隔天数');
        return;
      }
      this.visible8 = false;

    },
    setRule(){
      this.visible8 = true;
    },
    handleSelectSuper(v) {
      this.tempSuperTemplate = v;
      console.log(this.tempSuperTemplate)
    },
    openTemplate() {
      this.visible4 = true;
    },
    cancelChooseTemplate() {
      this.visible4 = false;
    },
    sureChooseTemplate() {
      if (!this.templateSelectd && this.tempSuperTemplate.length == 0) {
        this.$message.error('请选择模版');
        return;
      }
      if (this.activeTemlate == 0) {
        //超级模版
        this.tableDataII = this.tempSuperTemplate;
        this.serviceTenantName = JSON.parse(localStorage.userInfo).tenantName;
        this.serviceTenantGuid = localStorage.guid;
        this.tableDataII.forEach((item) => {
          if (item.taskTotalType == '固定量人均') {
            item.taskTotal = item.taskTotal * item.staffTotal;
          }
          if (item.goodsInfo) {
            var goodsInfo = JSON.parse(item.goodsInfo);
            goodsInfo.forEach((el) => {
              el.goodsCount = Math.ceil(item.taskTotal / goodsInfo.length);
            });
            item.goodsInfo = JSON.stringify(goodsInfo);
          }
        });
      } else {
        //普通模版
        this.chooseTemplate = this.templateSelectd;
        this.getTemplateDetail(this.chooseTemplate.guid);
      }

      this.visible4 = false;
    },
    handleChangeCompany(v) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //单选实现
    handleSelectScheme(selection, row) {
      this.$refs.dataTable.clearSelection();
      if (selection.length == 0) {
        return;
      }
      if (row) {
        this.templateSelectd = row;
        this.$refs.dataTable.toggleRowSelection(row, true);
        console.log(this.templateSelectd);
      }
    },
    btn(row, col, event) {
      row.flag = !row.flag;
      this.$refs.dataTable.toggleRowSelection(row, row.flag);
    },

    getSendTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    switchTemlate() { },
    renderHeader: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              ['每个品种的任务量 = 任务量除以品种个数'],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    getTenantTaskNote(detail) {
      if (detail.taskTotalType == '固定量人均') {
        var total = detail.taskTotal;
        return detail.tenantTaskNote.replace('#总任务量#', total);
      } else if (detail.taskTotalType == '系统计算') {
        var total = detail.taskTotal;
        return detail.tenantTaskNote.replace('#总任务量#', total);
      }
    },
    handleCounterChange(goodsIndex, detail) {
      var tableDataII = this.tableDataII;
      if (detail.goodsInfo) {
        var list = JSON.parse(detail.goodsInfo);
        list.forEach((item) => {
          item.goodsCount = Math.ceil(detail.taskTotal / list.length);
        });
        this.tableDataII[goodsIndex].goodsInfo = JSON.stringify(list);
      }
    },
    //提交品种
    submitForm() {
      var goodsIndex = this.goodsIndex;
      this.visible2 = false;
      var taskTotal = 0;
      this.tableData.forEach((item) => {
        taskTotal += item.goodsCount;
      });
      this.tableDataII[goodsIndex].goodsInfo = JSON.stringify(this.tableData);
      this.tableDataII[goodsIndex].taskTotal = taskTotal;
    },
    //点击填写数量
    addAmount(goodsIndex, list, taskTotal) {
      this.visible2 = true;
      this.goodsIndex = goodsIndex;
      var list = JSON.parse(list);
      list.forEach((item) => {
        item.goodsCount = Math.ceil(taskTotal / list.length);
      });
      this.tableData = list;
    },

    //获取项目模版
    getSchemeTemplateList() {
      let self = this;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/task-set/template/get-list`, this.schemPage)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.schemeTemplateList = res.data.data.records;
            self.schemPage.totalPage = res.data.data.totalPages;
            self.schemPage.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    emptySearchScheme() {
      this.schemPage = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        isUse: 'Y',
        tenantName: '', //药企名称
        templateName: '', //模版名称
        sendTenantGuid: '',
        tenantGuid: localStorage.guid,
        serviceTenantGuid: localStorage.guid,
        organisationInfo: '',
      };
      this.getSchemeTemplateList();
    },
    handleSizeChange(val) {
      let self = this;
      self.schemPage.pageSize = val;
      this.getSchemeTemplateList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.schemPage.pageIndex = val;
      this.getSchemeTemplateList();
    },
    handleSizeChange1(val) {
      let self = this;
      self.superPage.pageSize = val;
      this.getSuperTemplateList();
    },
    handleCurrentChange1(val) {
      let self = this;
      self.superPage.pageIndex = val;
      this.getSuperTemplateList();
    },

    //获取超级模版
    getSuperTemplateList() {
      var self = this;
      this.tableDataII = [];
      let param = JSON.parse(JSON.stringify(this.superPage))
      param.taskContentName = []
      if (this.superPage.taskContentName) param.taskContentName.push(this.superPage.taskContentName)
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/task-set/template/get-detail`, param)
        .then((res) => {
          if (res.data.code != '00000') {
            this.$message.error(res.data.msg);
            return;
          }

          self.superTemplateList = res.data.data.detailList;
          self.superPage.totalRows = res.data.data.taskTotal;
        });
    },
    emptySearchSuper() {
      this.superPage = {
        tenantGuid: localStorage.guid,
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        taskContentName: '', //任务名称
        menuName: '', //菜单名称
      };
      this.getSuperTemplateList();
    },
    //获取模版详情
    getTemplateDetail(guid) {
      var req = {
        templateGuid: guid,
        pageSize: -1,
        pageIndex: 1
      };
      var self = this;
      this.tableDataII = [];
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/template/get-detail`, req).then((res) => {
        if (res.data.code != '00000') {
          this.$message.error(res.data.msg);
          return;
        }
        self.tableDataII = res.data.data.detailList;
        self.serviceTenantName = res.data.data.serviceTenantName;
        self.serviceTenantGuid = res.data.data.serviceTenantGuid;
        self.templateGuid = res.data.data.guid;
        self.tableDataII.forEach((item) => {
          if (item.taskTotalType == '固定量人均') {
            item.taskTotal = item.taskTotal * item.staffTotal;
          }
          if (item.goodsInfo) {
            var goodsInfo = JSON.parse(item.goodsInfo);
            goodsInfo.forEach((el) => {
              el.goodsCount = Math.ceil(item.taskTotal / goodsInfo.length);
            });
            item.goodsInfo = JSON.stringify(goodsInfo);
          }
        });
      });
    },
    addPeople() {
      if (!this.sendTenantName) {
        this.$message.error('请选择委托方');
        return;
      }
      if (this.disabled) return;
      this.visible3 = true;
    },
    getDetail() {
      var self = this;
      if (!this.$route.query.guid) return;
      if (this.$route.query.is_edit) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }

      var req = {
        guid: this.$route.query.guid,
      };
      this.fullscreenLoading = true;
      self.api.get(`/${serverConfig.msSalesPerformService}/task/data/get-base-detail`, req).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          var detail = res.data.data;
          var taskTitle = detail.taskTitle;
          this.originalTaskTitle = detail.taskTitle;
          var nextDay = detail.nextDay;
          var orderType = detail.orderType;
          var regex = /\((.+?)\)/g; 
          this.timeType = detail.timeType;
          if (taskTitle.indexOf('(') > -1) {
            this.newTaskTitleTxt = taskTitle.match(regex)[0].replace("(", "").replace(")", "");
            this.taskTitle = taskTitle.split('(')[0];
          } else {
            this.taskTitle = taskTitle;
          }
          if (orderType == 1 || !orderType) {
            this.orderType = '1';
            this.isNextDay = false;
            this.nextDay = '';
          }
          if (orderType == 2) {
            this.orderType = '2';
            this.isNextDay = true;
            this.nextDay = nextDay;
          }
          this.taskType = detail.taskType;
          setTimeout(() => {
            this.startTime = moment(detail.startTime).format('YYYY-MM-DD');
            this.endTime = moment(detail.endTime).format('YYYY-MM-DD');
          }, 100);
          this.departmentData = [
            {
              staffName: detail.senderStaffName,
              guid: detail.senderStaffGuid,
            },
          ];
          this.departmentList = [
            {
              staffName: detail.senderStaffName,
              guid: detail.senderStaffGuid,
            },
          ];
          //this.getOrganisation(detail.tenantGuid);
          //执行部门
          if (detail.organisationInfo) {
            var departmentListII = [];
            var organisationInfo = JSON.parse(detail.oldOrganisationInfo || detail.organisationInfo);
            organisationInfo.forEach((item) => {
              departmentListII.push({
                guid: item.guid,
                organisationName: item.name,
                nodeType:item.objectType=='组织'||!item.objectType?'1':'2'

              });
            });
            this.departmentListII = departmentListII;
          }
          this.tableDataII = detail.taskDetailList;
          this.taskDetailList = detail.taskDetailList;
          this.templateGuid = detail.templateGuid;
          this.templateName = detail.templateName;
          this.serviceTenantName = detail.serviceTenantName;
          this.serviceTenantGuid = detail.serviceTenantGuid;
          this.sendTenantName = detail.tenantName;
          this.sendTenantGuid = detail.tenantGuid;
          this.taskPriceModel = detail.taskPriceModel;
          this.tableDataII.forEach(item => {
            if (item.surveyTenantGuid) {
              item.surveyObj = {
                surveyTenantGuid: item.surveyTenantGuid,
                surveyTitle: item.surveyTitle
              }
            }
          })
          this.detail = detail;
          if (this.isChangeService) { // !转派的任务包名可全部修改
            this.taskTitle = detail.taskTitle;
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    submitReq() {
      if (this.timeType == '自定义' && this.timeRange) {
        this.startTime = this.timeRange[0];
        this.endTime = this.timeRange[1];
      }
      var self = this;
      // if (!this.taskTitle) {
      //   self.$message.error('请输入任务标题');
      //   return;
      // }
      if (!this.sendTenantName) {
        self.$message.error('请选择委托方');
        return;
      }

      if (!this.startTime) {
        self.$message.error('请选择时间');
        return;
      }
      if (this.departmentList.length == 0) {
        self.$message.error('请选择发布人员');
        return;
      }

      if (this.departmentListII.length == 0) {
        self.$message.error('请选择执行部门');
        return;
      }
      if (this.tableDataII.length == 0) {
        self.$message.error('请选择任务模版');
        return;
      }

      var taskTotalUnitList = this.$refs.templateConfig.taskTotalUnitList;
      var taskTypeList = this.$refs.templateConfig.taskTypeList;
      var tableDataII = this.$refs.templateConfig.tableData;
      var provinceArray = this.$refs.templateConfig.provinceArray;

      var departmentList = this.departmentList;
      var senderStaffGuid = departmentList[0].guid;
      var senderStaffName = departmentList[0].staffName;
      var tenantName = this.sendTenantName;
      var tenantGuid = this.sendTenantGuid;
      var templateGuid = this.templateGuid;
      var detailParam = [];
      var organisationInfo = [];
      this.departmentListII.forEach((item) => {
        organisationInfo.push({
          guid: item.guid,
          name: item.organisationName,
          objectType:item.nodeType=='2'?'人员':'组织'
        });
      });
      console.log(tableDataII)
      try {
        tableDataII.forEach((el, orderIndex) => {
          var detail = {
            taskContentName: '', //任务名称名称
            taskContentGuid: '', //任务名称GUID
            taskContentType: '', //任务名称类别
            taskType: '', //任务大类
            taskTypeGuid: '', //任务大类Guid
            taskTotal: '', //任务总量
            taskTotalUnit: '', //任务总量单位
            taskPrice: '', //任务价格
            taskPriceUnit: '',
            menuUrl: '', //菜单地址
            taskContentJson:'',
            menuName: '', //菜单名称
            taskTotalType: '', //任务总量类型(????)
            taskTotal: '', //任务总量
            taskTotalUnit: '', //任务总量单位
            taskPrice: '', //任务价格
            taskPriceUnit: '', //任务价格单位
            staffWorkNote: '', //业务员工作要求
            staffTaskNote: '', //业务员任务文案
            tenantWorkNote: '', //药企工作要求
            tenantTaskNote: '', //药企任务文案
            countRule: '', //统计规则
            organisationInfo: JSON.stringify(organisationInfo),
            clientObject: null, //客户对象json
            clientArea: '', //客户区域json
            goodsInfo: '', //商品信息json
            taskIcon: '', //	string任务图标json
            settleRule: '1',
            settlePercent: '',
            isAskClock: '', //是否要求打卡 是/否
            isAskPhoto: '', //是否要求拍照 是/否
            minAskPhoto: '', //最少要求拍照数量
            isAskUpload: '', //是否要求上传资料 是/否
            minAskUpload: '', //最少上传资料数量
            orderIndex: orderIndex + 1,
            templateDetailGuid: el.guid,
            taskLabel:'',
            surveyLabelList: el.surveyLabelList,
          };
          //任务大类
          detail.taskType = el.taskType;
          detail.taskTypeGuid = el.taskTypeGuid;

          if (!el.taskType) {
            throw new Error('请选择任务大类');
          }

          //任务名称
          detail.taskContentGuid = el.guid;
          detail.menuUrl = el.menuUrl;
          detail.taskContentJson = el.taskContentJson;
          detail.menuName = el.menuName;
          detail.taskContentType = el.taskContentType;
          detail.taskContentName = el.taskContentName;
          detail.clientObject = el.clientObject;
          if (!el.taskContentName) {
            throw new Error('请选择任务名称');
          }
          detail.surveyTenantGuid = el.surveyObj && el.surveyObj.surveyTenantGuid || null;
          if (detail.menuUrl == '/subFillingApp/questionnaireFilling' && !detail.surveyTenantGuid) {
            throw new Error('请选择一个问卷');
          }
          //根模版
          detail.parentTemplateDetailGuid = el.parentTemplateDetailGuid;
          detail.parentTemplateDetailName = el.parentTemplateDetailName;

          detail.tenantTaskPrice = el.tenantTaskPrice;
          detail.tenantTaskPriceUnit = el.tenantTaskPriceUnit;
          if (!el.tenantTaskPrice) {
            throw new Error('请填写药企报价');
          }
          if (!el.tenantTaskPriceUnit) {
            throw new Error('请填写药企报价单位');
          }

          //业务员报价、业务员报价单位
          detail.taskPrice = el.taskPrice;
          detail.taskPriceUnit = el.taskPriceUnit;
          if (!el.taskPrice) {
            throw new Error('请填写业务员报价');
          }
          if (!el.taskPriceUnit) {
            throw new Error('请填写业务员报价单位');
          }

          //标准量、标准量单位
          detail.taskTotal = el.taskTotal;
          detail.taskTotalUnit = el.taskTotalUnit;
          // if (!el.taskTotal) {
          //   throw new Error('请填写任务量');
          // }
          if (!el.taskTotalUnit) {
            throw new Error('请选择任务量单位');
          }
          if (!el.taskPriceUnit) {
            throw new Error('请填写业务员报价单位');
          }
          detail.settleRule = el.settleRule;
          detail.settlePercent = el.settlePercent;

          if (!el.surveyLabelList?.length) {
            throw new Error('请选择标签');
          }

          detail.isAskClock = el.isAskClock;
          if (!el.isAskClock) {
            throw new Error('请选择是否打卡');
          }
          detail.isAskPhoto = el.isAskPhoto;
          if (!el.isAskPhoto) {
            throw new Error('请选择是否拍照');
          }
          detail.minAskPhoto = el.minAskPhoto;
          if (!el.minAskPhoto && el.isAskPhoto == '是') {
            throw new Error('请填写最少拍照数量');
          }
          detail.isAskUpload = el.isAskUpload;
          if (!el.isAskUpload) {
            throw new Error('请选择是否上传资料');
          }
          detail.minAskUpload = el.minAskUpload;
          if (!el.minAskUpload && el.isAskUpload == '是') {
            throw new Error('请填写最少上传资料数');
          }

          //标准量、标准量单位
          detail.taskTotal = el.taskTotal;
          detail.taskTotalUnit = el.taskTotalUnit;
          // if (!el.taskTotal) {
          //   throw new Error('请填写任务量');
          // }
          if (!el.taskTotalUnit) {
            throw new Error('请选择任务量单位');
          }

          //任务要求
          detail.taskTag = JSON.stringify(el.taskTag);
          if (el.taskTag && el.taskTag.length == 0) {
            throw new Error('请选择任务要求');
          }

          //药企任务文案 、药企工作要求 运营任务文案 运营工作文案
          detail.staffWorkNote = JSON.stringify(el.staffWorkNote.split('\n'));
          detail.staffTaskNote = el.staffTaskNote;
          detail.tenantWorkNote = el.tenantWorkNote;
          detail.tenantTaskNote = el.tenantTaskNote;
          if (!el.tenantTaskNote) {
            throw new Error('请至【更多内容编辑】中填写药企任务文案');
          }
          if (!el.staffTaskNote) {
            throw new Error('请至【更多内容编辑】中填写运营方任务文案');
          }
          if (!el.staffWorkNote) {
            throw new Error('请至【更多内容编辑】中填写运营方工作要求');
          }

          //客户区域
          var clientArea = [];

          if (el.clientAreaRadio == '本区域' || el.clientAreaRadio == '不限区域') {
            clientArea.push({
              name: el.clientAreaRadio,
              guid: '',
            });
          } else {
            console.log( el.clientAreaLabel)
            console.log( el.clientArea)
            console.log(el.clientAreaLabel)
            el.clientArea.forEach((item,index) => {
              clientArea.push({
                name:el.clientAreaLabel[index],
                guid: item[1],
                provinceCode: item[0]
              });
            });
            // el.clientArea.forEach((item) => {
            //   provinceArray.forEach((j) => {
            //     if (j.name == item) {
            //       clientArea.push({
            //         name: item,
            //         guid: j.code,
            //       });
            //     }
            //   });
            // });
          }
          detail.clientArea = JSON.stringify(clientArea);

          //商品
          var goodsInfo = [];
          if (el.multipleSelection && el.multipleSelection.length != 0) {
            el.multipleSelection.forEach((i) => {
              goodsInfo.push({
                name: i.goodsName,
                guid: i.guid,
                goodsCount: Math.ceil(detail.taskTotal / el.multipleSelection.length),
                goodsUnit: i.unitStyle,
                goodsSpec: i.goodsSpec,
              });
            });
            detail.goodsInfo = goodsInfo.length == 0 ? null : JSON.stringify(goodsInfo);
          } else {
            detail.goodsInfo = null;
          }
          //任务要求
          detail.taskTag = JSON.stringify(el.taskTag);
          if (el.taskTag && el.taskTag.length == 0) {
            throw new Error('请至【更多内容编辑】中选择任务要求');
          }

          //任务图标
          detail.taskIcon = JSON.stringify(el.fileList);
          if (el.fileList && el.fileList.length == 0) {
            throw new Error('请至【更多内容编辑】中上传任务图标');
          }

          //规则
          taskTotalUnitList.forEach((item) => {
            if (item.paramValue == el.taskTotalUnit) {
              detail.countRule = item.paramValue1;
            }
          });

          //任务总量类型
          detail.taskTotalType = el.calcType;

          if (el.isOpenMaxTask == 'Y') {
            if (el.maxTaskValue >= 0 && el.maxTaskValue <= 100) {
              detail.isOpenMaxTask = 'Y';
              detail.maxTaskValue = +el.maxTaskValue;
            } else {
              throw new Error('请填写正确上限百分比');
            }
          } else {
            detail.isOpenMaxTask = 'N';
            detail.maxTaskValue = 0;
          }
          detail.taskLabel =  el.taskLabel&&el.taskLabel.length?JSON.stringify(el.taskLabel):null

          // 数据标注行（2026-09-21 拍板：待派发态三项可改必可存）——labelConfig 承载选择标注数据/
          // 标注人员要求/质检比例三项，templateConfig 编辑时已同步写回 el.labelConfig，此处随明细提交；
          // 后端 edit 待派发分支据此同步 ext 行与数据集占用
          if (el.taskContentType === 'SJBZ') {
            if (!el.labelConfig) {
              throw new Error('任务明细【' + (el.taskContentName || '数据标注') + '】未选择标注数据，请选择标注数据');
            }
            detail.labelConfig = el.labelConfig;
            // 任务量路由按计算方式分流（2026-09-29 拍板计算方式不写死）：固定量人均=以量定人，
            // 编辑态（is_edit→disabled=false）取输入框人均 el.taskTotal 进 taskAvg、taskTotal 置
            // null 由后端三锚点按数据集条数回填；系统计算=总量语义（输入框值=标注数据带出的数据量），
            // 直接走 taskTotal。只读态输入框未渲染：固定量人均取库值 el.taskAvg 回传（"修改"按钮
            // 恒可点，两态必须分流，否则只读态提交会把总量洗进 task_avg），其余行 taskTotal 原样
            const isPerCapitaRow = el.calcType == '固定量人均';
            if (!this.disabled) {
              // 口径3 任务量必填/非零（2026-11-05 收窄）：仅固定量人均仍拦（值=人均存 task_avg 拆解
              // 消费）；系统计算输入框已置灰（值=数据集条目数带出，不参与业务，后端落库置 null），
              // 免必填/非零拦截；只读态无输入入口不校验
              if (isPerCapitaRow) {
                if (el.taskTotal == null || el.taskTotal === '') {
                  throw new Error(`任务明细【${el.taskContentName || '数据标注'}】请填写人均任务量`);
                }
                if (+el.taskTotal === 0) {
                  throw new Error(`任务明细【${el.taskContentName || '数据标注'}】限量的任务量不能为0`);
                }
              }
              if (isPerCapitaRow) {
                detail.taskAvg = el.taskTotal != null && el.taskTotal !== '' ? el.taskTotal : null;
                detail.taskTotal = null;
              } else {
                detail.taskAvg = null;
                detail.taskTotal = el.taskTotal != null && el.taskTotal !== '' ? el.taskTotal : null;
              }
            } else {
              detail.taskAvg = isPerCapitaRow && el.taskAvg > 0 ? el.taskAvg : null;
              detail.taskTotal = isPerCapitaRow ? null : el.taskTotal;
            }
          }

          detailParam.push(detail);
          console.log(detailParam);
        });
      } catch (e) {
        this.$message.error(e.message);
        return;
      }
      this.taskDetailList.forEach((el, index) => {
        detailParam[index].guid = el.guid;
      })
      var req = {
        currentTenantGuid:localStorage.guid,
        orderType: this.orderType,
        nextDay: this.orderType == 2 ? +this.nextDay : 0,
        guid: this.$route.query.guid,
        taskDetailList: detailParam,
        isUpdateDetail: true,
        state: this.$route.query.state,
        // 转派支持修改全部名称
        taskTitle:this.isChangeService ? this.taskTitle : (this.taskTitle && this.newTaskTitleTxt ? this.taskTitle + '(' + this.newTaskTitleTxt + ')' : this.taskTitle),
      };
      
      if (this.$route.query.guid) {
        req.guid = this.$route.query.guid;
      }
      this.fullscreenLoading = true;
      var url = `/${serverConfig.msSalesPerformService}/task/data/edit`;
      self.api.postJson(url, req).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('修改成功');
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getDeliverName(res) {
      var list = JSON.parse(res);
      var strList = [];
      list.forEach((item) => {
        strList.push(item.name);
      });
      return strList.join('、');
    },
    getDeliverNameII(res) {
      var list = res;
      var strList = [];
      if (list.length == 0) return;
      list.forEach((item) => {
        strList.push(item.organisationName);
      });
      return strList.join('、');
    },
    getTaskContentList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/content/get-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.taskContentList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: this.$getValueListByKey('上游客户分类'),
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    search() {
      let self = this;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/template/get-list`, this.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectFactory(val) {
      var tenantList = this.tenantList;
      this.tenantName = val;
      tenantList.forEach((item) => {
        if (item.tenantName == this.tenantName) {
          this.area = [];
          this.departmentList = [];
          this.departmentData = [];
          this.areaData = [];
          this.delList = [];
          this.filterText = '';
          this.areaII = [];
          this.departmentListII = [];
          this.departmentDataII = [];
          this.areaDataII = [];
          this.delListII = [];
          this.filterTextII = '';
          this.sendTenantGuid = item.guid;
          // this.getOrganisation(item.guid);
          this.getOrganisationII(item.guid);
        }
      });
    },
    //获取组织
    getOrganisationII(guid) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail?bizState=Y&tenantGuid=` + guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaDataII = res.data.data;
          } else {
            self.$message.error(res.data.msg);
            self.areaDataII = [];
          }
        });
    },
    handleSelectionChangeII(val) {
      let self = this;
      self.delListII = val;
    },
    filterNodeII(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    //确定选择部门
    departmentSureII() {
      if (this.departmentListII.length == 0) {
        this.$message.error('请勾选部门！');
        return;
      }
      this.visible5 = false;
    },
    //删除部门
    delDepartmentII() {
      let self = this;
      if (self.delListII == null || self.delListII.length == 0) {
        self.$message.error('请勾选部门！');
        return;
      }
      self.delListII.forEach(function (j) {
        self.departmentListII.forEach(function (i, index) {
          if (i.guid == j.guid) {
            self.departmentListII.splice(index, 1);
          }
        });
      });
      self.delListII.forEach(function (m) {
        self.areaII.forEach(function (n, idn) {
          if (JSON.parse(n).guid == m.guid) {
            self.areaII.splice(idn, 1);
          }
        });
      });
    },

    //部门弹框选择
    handleNodeClickII(data) {
      this.departmentListII = this.$refs.treeII.getCheckedNodes(false);
      console.log(this.departmentListII);
      this.$forceUpdate();
    },
    isContainOrg(arr, guid) {
      if (!arr.length) return 0;
      let flag = arr.findIndex((one) => {
        return one == guid;
      });
      if (flag == -1) {
        return 0;
      } else {
        return 1;
      }
    },
    disabledTreeNode(data, node) {
      let list = this.departmentListII;
      if (list.length) {
        let flag = 0;
        let parentGuids = data.parentGuids ? data.parentGuids : [];
        for (let i = 0; i < list.length; i++) {
          let checkedParentGuids = list[i].parentGuids ? list[i].parentGuids : [];
          if (this.isContainOrg(parentGuids, list[i].guid)) {
            flag = 1;
            break;
          } else if (this.isContainOrg(checkedParentGuids, data.guid)) {
            flag = 1;
            break;
          } else {
            flag = 0;
          }
        }
        return flag > 0;
      } else {
        return false;
      }
    },
    //查询人员
    getStaff(organisationGuid) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: 10,
        tenantGuid: this.sendTenantGuid,
        staffType: '1',
        bizState: 'Y',
        organisationGuid: organisationGuid,
      };
      return new Promise((resolve, reject) => {
        self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, query).then((res) => {
          self.loadingCount--;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (self.loadingCount == 0) {
              self.fullscreenLoading = false;
            }
            const records = res.data.data.records;
            (records || []).forEach((k) => {
              k.label = k.staffName;
              k.id = k.guid;
              k.icon = require('../../assets/images/icon_per.png');
            });
            resolve(records);
          } else {
            self.fullscreenLoading = false;
            self.$message.error(res.data.msg);
          }
        });
      });
    },
    //部门弹框选择
    handleNodeClick1(data) {
      this.departmentList = this.$refs.treeDep.getCheckedNodes(true);
      this.$forceUpdate();
    },
    filterNodeDep(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleCheckChange(data, checked, node) {
      if (checked == true) {
        this.checkedId = data.guid;
        this.$refs.treeDep.setCheckedNodes([data]);
      }
    },
    nodeClick(data, checked, node) {
      this.checkedId = data.guid;
      this.$refs.treeDep.setCheckedNodes([data]);
    },
    //确定选择部门
    departmentSure() {
      this.departmentData = this.departmentList;
      this.visible3 = false;
    },
    //删除单个部门
    delDepartmentSingle(index) {
      if (this.disabled) return;
      this.departmentData.splice(index, 1);
      this.departmentList = this.departmentData;
      this.area.splice(index, 1);
      this.$refs.treeDep.setCheckedKeys([]);
      // this.departmentList.splice(index,1)
    },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选成员！');
        return;
      }
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.guid == j.guid) {
            self.departmentList.splice(index, 1);
            this.$refs.treeDep.setCheckedKeys([]);
          }
        });
      });
      self.delList.forEach(function (m) {
        self.area.forEach(function (n, idn) {
          if (JSON.parse(n).guid == m.guid) {
            self.area.splice(idn, 1);
          }
        });
      });
    },
    handleSelectionChange1(val) {
      let self = this;
      self.delList = val;
      console.log(val);
    },
    checkTaskTitle(val) {
      if (!val) {
        this.taskTitle = this.originalTaskTitle
        this.$message.error('任务包名称不能为空')
      }
    }
  },
};
</script> 
<style>
.service label {
  width: 80px !important;
}

.base-info label {
  width: 80px !important;
}
</style>
<style scoped>
.title-memo{
  display:flex;
  align-items: center;

}
.title-memo .title-memo-title{
  display:flex;
  word-break: keep-all;
  flex-wrap: nowrap;
  margin-right:10px;

    
}
.title-memo-label{
  max-width:370px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow: ellipsis;
}
.content {
  background: #fff;
  font-size: 18px;
}

/deep/.el-form-item {
  display: flex;
  align-items: center;
}

/deep/.el-form-item__content {
  margin-left: 20px !important;
}

.p16 {
  padding-top: 0;
  padding-left: 30px;
  padding-right: 30px;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.management-list {
  display: flex;
  align-items: center;
  margin-left: 24px;
  margin-bottom: 20px;
  font-size: 14px;
  color: #606266;
}

.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 0 !important;
}

.management-name {
  flex-shrink: 0;
  margin-right: 33px;
}

.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  /* border: 1px solid grey; */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
  border-radius: 20px;
  background: #DEEFEF;
  border: 0 none;
}

.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}

.input-item .input-title {
  margin-right: 14px;
}

.title {
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  background: #fff;
  color: #323233;
  padding:16px 0 10px 20px;
  margin-bottom: 0;
}


.template-box {
  width: 300px;
  float: left;
  border: 1px solid #dcdfe6;
  height: 34px;
  border-radius: 4px;
  line-height: 34px;
  text-align: left;
  text-indent: 10px;
  cursor: pointer;
  color: #606266;
}

.search-col {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.search-row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.search-name {
   width: 80px;
  word-break: keep-all;
}

/deep/ .has-gutter .el-checkbox {
  display: none;
}

.base-content {
  display: flex;
  font-size: 15px;
  padding: 20px 0;
}

.base-info {
  display: flex;
  align-items: center;
  margin-left: 23px;
  margin-bottom: 20px;
}

.base-info .base-title {
  word-break: keep-all;
  font-size: 14px;
  display: flex;
}

.depart-choose {
  width: 300px;
  height: 34px;
  border: 1px solid #dcdfe6;
  box-sizing: content-box;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-left: 34px;
}

.depart-choose span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.place-choose {
  padding-left: 10px;
  color: rgb(185, 185, 185);
}

.place-show {
  padding-left: 20px;
}
.header {
  background: #fff;
  margin: 4px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;

}

.header .back {
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}
.header .task-title{
    flex:1;
    font-weight:500px;
}
.header .task-title span{
  font-size:12px;
  color:#4fa1a4;
  margin-left:5px;
  cursor:pointer;
}
.basic-conetent{
  background: #fff;
  margin-bottom:4px;
}
.btn-groups{
  background: #fff;
}
.btn-groups .btn-common{
  width: 120px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.btn-border-green{
  background: #fff;
  color: #4fa1a4;
  border: 1px solid #4fa1a4;
}
.btn-border-gray{
  background: #f0f0f0;
  color: #323233;
  border: 1px solid #dcdee0; 
}
</style>

